import { SerializableObject } from '../../common-react/core';

import { DimensionUnit, WeightUnit } from './parcel.do';

export class ShipmentServiceBracketCustomInput extends SerializableObject {
  // The weight unit to use on the input form, e.g. “kg”
  public weightUnit: WeightUnit;

  // The minimum weight value, i.e. the lower limit on the weight slider input.
  public weightMinimum: number;

  // The maximum weight value, i.e. the upper limit on the weight slider input.
  public weightMaximum: number;

  // This is true, then the User is not required to provide the weight of the parcel
  public weightOptional: boolean;

  // The length/height/width unit to use on the input form, e.g. “cm”
  public dimensionUnit: DimensionUnit;

  // If true, then the length dimension field is a required field in the Custom Input form.
  public lengthRequired: boolean;

  // If true, then the height dimension field is a required field in the Custom Input form.
  public heightRequired: boolean;

  // If true, then the width dimension field is a required field in the Custom Input form.
  public widthRequired: boolean;
}
